const CONFIG = {
    // 包名
    pkgname: 'com.guokr.mobile',
    // app scheme
    scheme: 'guokrapp',
    // appstore，暂未用到
    appstore: 'https://apps.apple.com/cn/app/%E6%9E%9C%E5%A3%B3-%E7%A7%91%E6%8A%80%E6%9C%89%E6%84%8F%E6%80%9D/id1501785252',
    // 应用宝链接，会自动跳转appstore和唤起android app
    yyb: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.guokr.mobile&ckey=CK1455633687125',
    // 不同环境将要进行访问的universal host
    // 解决：由于iOS需要跨域才可唤起App
    universalLinks: {
        test01: 'https://guokrapp-test00.guokr.cn',
        test00: 'https://guokrapp-test01.guokr.cn',
        localhost: 'https://guokrapp-test01.guokr.cn',
        production: 'https://guokrapp-test00.guokr.cn'
    }
}

const Browser = () => {
    const UA = navigator.userAgent || ''
    return {
        isAndroid: /Android/i.test(UA),
        isIOS: /iPhone|iPad|iPod/i.test(UA),
        isWx: /micromessenger/i.test(UA),
        isSafari: /Safari/i.test(UA) && !/Chrome/.test(UA),
        getIOSVersion: () => {
            return parseInt(navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)[1], 10)
        }
    }
}

class AppLink {
    constructor() {
        this.UA = navigator.userAgent || ''
        this.browser = Browser()

        this.config = CONFIG

        this.timer = null
    }

    /**
     * 进行跳转
     * @param {String} url 跳转的链接
     */
    _go(url) {
        window.location.href = url
    }

    /**
     * 根据页面path获取完整的scheme
     * @param {String} path 页面path
     */
    _getSchemeWithPath(path) {
        if ((path === '' || path === '/')) {
            // scheme唤起App必须有App支持的路径
            return `${this.config.scheme}://home/`
        }
        return `${this.config.scheme}:/${path}`
    }

    /**
     * 通过scheme唤起app
     * @param {String} path 页面path
     */
    _goScheme(path, query) {
        const url = this._getSchemeWithPath(path)

        this._go(this.addQuery(url, query))
    }
    /**
     * 跳转至应用宝
     * @param {String} path 页面path
     */
    _goYyb(path) {
        const scheme = this._getSchemeWithPath(path)
        let url = this.config.yyb
        // 添加链接参数
        url += `&ios_schema=${encodeURIComponent(scheme)}&android_schema=${encodeURIComponent(scheme)}`
        // if (this.browser.isIOS) url += `&gst

        this._go(url)
    }
    /**
     * 通过universalLink唤起App，多个环境跳转
     * 结合node/router/index.js，慎改
     * @param {String} path 页面path
     */
    _goUniversal(path, query = {}) {
        const origin = window.location.origin
        const envMatch = origin.match(/guokrapp-(\w+)/)
        let env = 'localhost'
        if (/guokr\.com/.test(origin)) {
            env = 'production'
        } else if (envMatch) {
            env = envMatch[1]
        }

        let url = this.config.universalLinks[env] + path + `?f=${env}`
        url = this.addQuery(url, query)

        this._go(url)
    }

    /**
     * 检查是否唤起
     * @param {Function} cb 回调
     */
    checkOpen(cb) {
        var inter = null
        var status = false
        var count = 0
        inter = window.setInterval(() => {
            count++
            status = document.hidden || document.webkitHidden
            if (status || count > 30) {
                cb(status)
                clearInterval(inter)
            }
        }, 30)
    }

    /**
     * 外部调用的入口函数
     */
    open({ path, query = {} }) {
        if (this.browser.isWx) {
            // 微信
            if (this.browser.isIOS) {
                this._goUniversal(path, query)
            } else {
                this._goYyb(path)
            }
        } else if (this.browser.isSafari) {
            this._goUniversal(path, query)
        } else {
            // 其他浏览器
            // 统一使用scheme
            this._goScheme(path, query)
            this.checkOpen((isSuccess) => {
                if (!isSuccess) this._goYyb(path)
            })
        }
    }

    addQuery(url = '', query = {}) {
        Object.keys(query).forEach(key => {
            const pre = /\?/.test(url) ? '&' : '?'
            url += `${pre}${key}=${query[key]}`
        })
        return url
    }
}

export default new AppLink()